import script from "./UserPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPortal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__